package org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_surcharge


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("updateCategory")
    val updateCategory: UpdateCategory?
)